module.exports = __webpack_public_path__ + "static/media/222-sahrawi-arab-democratic-republic.789bf608.svg";